module.exports = __webpack_public_path__ + "static/media/room-9.7b17c49f.jpeg";